import { getFirstBuilder } from './getFirstBuilder';
import { INewbuilding } from '../../../../types/newbuildingHeader';

export function getDefaultMessage(newbuilding: INewbuilding | null): string {
  const builder = getFirstBuilder(newbuilding);

  return builder?.chat?.defaultMessage ?? '';
}
